// 引入qrcode-decoder
import QrCode from 'qrcode-decoder'

import QRCode1 from 'qrcodejs2'

// 传入file对象，返回promise
export function getQrUrl(file) {
  // 获取临时路径
  let url = getObjectURL(file)
  // 初始化
  // let nurl=crateQrcode(url)
  
  const qr = new QrCode()
  // 解析二维码，返回promise

  return qr.decodeFromImage(url);
}

var crateQrcode=function (qrcode) {
	let data= new QRCode1('qrcode', {
		width: 150,
		height: 150, // 高度
		text: qrcode, // 二维码内容
		render: 'canvas', // 设置渲染方式（有两种方式 table和canvas，默认是canvas）
		background: '#f0f',
		foreground: '#ff0',
	  })
	  return data;
}

// 获取临时路径
var getObjectURL = function (file) {
  var url = null;
  if (window.createObjectURL != undefined) { // basic
    url = window.createObjectURL(file);
  } else if (window.URL != undefined) { // mozilla(firefox)
    url = window.URL.createObjectURL(file);
  } else if (window.webkitURL != undefined) { // webkit or chrome
    url = window.webkitURL.createObjectURL(file);
  }
  return url;
}
